export function replaceTextInRange(range: Range, newContent: string): void {
  const windowSelection = window.getSelection();
  if (!windowSelection) {
    throw new Error('No window selection available');
  }

  windowSelection.removeAllRanges();
  windowSelection.addRange(range);

  range.deleteContents();

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = newContent;

  const fragment = document.createDocumentFragment();
  let lastNode: Node | null = null;

  while (tempDiv.firstChild) {
    lastNode = fragment.appendChild(tempDiv.firstChild);
  }

  range.insertNode(fragment);

  if (lastNode) {
    range.setStartAfter(lastNode);
  }
  range.collapse(true);
  windowSelection.removeAllRanges();
  windowSelection.addRange(range);
}
